import { render, staticRenderFns } from "./APIDemo.vue?vue&type=template&id=cdcf646a"
import script from "./APIDemo.vue?vue&type=script&lang=js"
export * from "./APIDemo.vue?vue&type=script&lang=js"
import style0 from "./APIDemo.vue?vue&type=style&index=0&id=cdcf646a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/APIDemo.vue
// module id = null
// module chunks = 